// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.songwriter-link-toggle {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 17rem;
}
.songwriter-link-toggle .toggle-label-component .toggle-wrapper::before {
  content: "";
}`, "",{"version":3,"sources":["webpack://./src/kit/components/SongwriterCatalogBuilderToggle/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,YAAA;AACF;AAGM;EACE,WAAA;AADR","sourcesContent":[".songwriter-link-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  width: 17rem;\n\n  .toggle-label-component {\n    .toggle-wrapper {\n      &::before {\n        content: '';\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
